import { CountUp } from 'countup.js';

var defaultHeaderTextColor = 'white';
var lastScroll = 0;
function scrolled(){
  var scrollTop = $(window).scrollTop();

  if (scrollTop > 0 && lastScroll <= scrollTop){
    lastScroll = scrollTop;
    $('body').removeClass('scrolling-up').addClass('scrolling-down');
  }else{
    lastScroll = scrollTop;
    $('body').removeClass('scrolling-down').addClass('scrolling-up');
  }

  updateHeaderUi(scrollTop);
  $('.not-in-view-yet:in-viewport( '+ ($(window).height()/1.5) +' )').removeClass('not-in-view-yet');
  startCountingUp();

}

function removeProtectedContent(){
  if($('.main-wrap .wp-block-lazyblock-protected-content').length){
    const firstElement = $('.main-wrap .wp-block-lazyblock-protected-content').first();
    firstElement.nextAll().each(function(index) {
      if(index > 0 && !$(this).hasClass('blog-detail-section-share')){
        $(this).remove();
      } else {
        $(this).addClass('show-preview-only');
      }
  });
  }
}

function startCountingUp(){
  var circleInViewport = $('.circle-wrap.animate-on-scroll:not(.not-in-view-yet) .count-up');
  circleInViewport.each(function() {
    if(!$(this).hasClass('countingStarted')){
      $(this).addClass('countingStarted');
      var countUp = new CountUp($(this).attr('id'), parseFloat($(this).attr('data-count-up-value')), {
        decimalPlaces: parseInt($(this).attr('data-count-up-decimals')),
        duration: 4,
        separator: ' ',
      });
      if (!countUp.error) {
        countUp.start();
      } else {
        console.error(countUp.error);
      }
    }
  });
}

function updateHeaderUi(scrollTop){
  $('#fake-bg').css('top',-scrollTop);
  $('#fake-bg').attr('data-scroll-top',Math.floor(scrollTop));
  var sectionScrollTop = scrollTop + ($('#header').outerHeight() / 2);
  var textColorClass = null;
  var sectionTop = 0;
  var sectionBottom = 0;
  $('#fake-bg .fake-bg-section').each(function(){
    sectionBottom = parseFloat($(this).attr('data-section-bottom'));
    //do check
    if(sectionTop <= sectionScrollTop  && sectionScrollTop <= sectionBottom && textColorClass == null){
      textColorClass = $(this).attr('data-text-color');
    }
    sectionTop = sectionBottom;
  });
  var newHeaderTextColor = (textColorClass != null ? textColorClass : defaultHeaderTextColor);
  if(!$('body').hasClass('header-text-'+newHeaderTextColor)){
    $('body').removeClass('header-text-black header-text-white');
    $('body').addClass('header-text-'+newHeaderTextColor);
    $('.secondary-menu-wrap .btn-outline').removeClass('btn-outline-light btn-outline-dark');
    $('.secondary-menu-wrap .btn-outline').addClass('btn-outline-'+(newHeaderTextColor == 'white' ? 'light' : 'dark'));
  }

}

function scrollToElementByHashOnInit() {
  var hash = location.hash.replace('#','');

  if(hash && hash.length > 1 && $('[name="'+hash+'"]').length){
      $('html, body').animate({ scrollTop: $('[name="'+hash+'"]').offset().top - $('#header').outerHeight()}, 500);
  }
  if(hash && hash.length > 1 && hash.indexOf('faq-') > -1){
    var faqId = hash.replace('faq-','');
    if($('.faq-accordion-section .card[data-faq-id="'+faqId+'"]').length){
      if($('.faq-accordion-section .card-header .btn[data-faq-id="'+faqId+'"]').first().hasClass('collapsed')){
        $('.faq-accordion-section .card-header .btn[data-faq-id="'+faqId+'"]').first().trigger('click');
      }

      $('html, body').animate({ scrollTop: $('[data-faq-id="'+faqId+'"]').offset().top - $('#header').outerHeight()}, 500);
    }
  }
}

function onResize(){
  $('#fake-bg').html('');
    var totalHeight = 0;
    $('main .bg-section').each(function(){
      var bgHeight =  $(this).outerHeight();
      var textColor = $(this).hasClass('header-dark-text') ? 'black' : defaultHeaderTextColor;
      totalHeight = totalHeight + bgHeight;
       $('#fake-bg').append('<div class="fake-bg-section '+$(this).attr('class')+'" style="height:'+bgHeight+'px" data-section-bottom="'+totalHeight+'" data-text-color="'+textColor+'"></div>');
    });
  $('#fake-bg').css('height',totalHeight);
}

function setAdditionalFormData() {
      $('[name="your-subject"]').val(document.title);
      $('[name="your-lang"]').val($('html').attr('lang'));
      $('[name="your-url"]').val(window.location.href);
      $('[name="your-page-id"]').val(wpPageId);
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param); // Returns the value or null if the parameter doesn't exist
}

function scrollToFirstElementWithClass(className) {
  const element = document.querySelector(`.${className}`);
  if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
      console.log(`No element found with the class "${className}"`);
  }
}

export default {


  init() {


    // JavaScript to be fired on all pages
      removeProtectedContent();
      setAdditionalFormData();
      onResize();
      $(window).scroll(function() {
        scrolled();
      });


      $(window).on('load',function() {
        onResize();
        scrolled();
        // scrollToElementByHashOnInit();
        $('header .static-logo-svg').removeClass('hide-on-loaded');
        $('header .animated-logo-svg').removeClass('hide-on-loading');
        setTimeout(onResize,1000);
        setAdditionalFormData();
      });




    var menuFormAnchorSelector = '.menu-item a[href="#form"]';
    if($(menuFormAnchorSelector).length){
      $('<button type="button" class="like-a btn btn-link" data-toggle="drawer" data-target="#contact-form-drawer">'+$(menuFormAnchorSelector).first().text()+'</button>').insertAfter(menuFormAnchorSelector);
      $(menuFormAnchorSelector).remove();
    }

    $(document).on('click','.open-contact-form', function(){
      $('#contact-form-drawer').drawer('show');
    });

    $(document).on('click','.show-access-form button', function(){
      const _parent = $(this).parents('.component-wrap').first();
      if(_parent.length){
        _parent.find('.access-form-wrap').removeClass('hidden');
        _parent.find('.show-access-form').remove();
      }
    });


    $('.carousel:not(#bg-carousel)').on('slid.bs.carousel', function () {
      var slideTo = $(this).find('.carousel-indicators .active').attr('data-slide-to');
      var captions = $('#captions-'+$(this).attr('id')).find('.carousel-custom-caption');
      var nextCaption = $('#captions-'+$(this).attr('id')).find('.carousel-custom-caption[data-caption-index='+slideTo+']');
      captions.removeClass('active').addClass('d-none');
      nextCaption.addClass('active').removeClass('d-none');

    });

    $('.embed-responsive-item.poster,.embed-responsive .play-icon').on('click',function(){
      var embedResponsive = $(this).parents('.embed-responsive').first();
      embedResponsive.find('.poster,.play-icon,.toggle-info,.caption').addClass('d-none');
      embedResponsive.find('.video').removeClass('d-none').trigger('click');
    });

    $('.faq-accordion-section .card-header .btn').on('click',function(){
      window.location.hash = 'faq-'+$(this).attr('data-faq-id');
    });

    //key control

    $(document).keydown(function(e){
      if (e.which == 37) {
        if($( '.carousel:in-viewport' ).length){
          $( '.carousel:in-viewport' ).first().carousel('pause').carousel('prev');
        }
         return false;
      }
      else if (e.which == 39) {
        if($( '.carousel:in-viewport' ).length){
          $( '.carousel:in-viewport' ).first().carousel('pause').carousel('next');
        }
        return false;
      }
    });

    $('.blogPosts-wrap .post-name-wrap').matchHeight();
    $('.heading-text-multi-columns .heading').matchHeight();
    $('.career-bottom-navigation .department-card-btn').matchHeight();


    document.addEventListener('wpcf7mailsent', function(event) {
      if($('#'+event.detail.unitTag).length){
        $('#'+event.detail.unitTag).parents('.access-form-wrap').first().addClass('mail-sent');
      }
    });

    if($('.restricted-access').length && getQueryParam('access-verified') == '1'){
      scrollToFirstElementWithClass('restricted-access');
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired




    onResize();
    setTimeout(onResize,500);
    scrolled();
    scrollToElementByHashOnInit();

    $( window ).on( 'resize', function() {
      setTimeout(onResize,500);
    } );

  $('.rte').each(function() {
    $(this).html($(this).html().replace(/(\s[ksvzouaiKSVZOUAI])\s/g, '$1&nbsp;'));
  });

    $('.slick-not-autoplay.one-slide-to-show').each(function(){
      var _this = $(this);
      _this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        arrows: true,
        draggable: true,
        dots: false,
        adaptiveHeight: true,
      });
    });

    $('.slick-autoplay').each(function(){
      var _this = $(this);
      var _autoplaySpeed = 2000;
      _this.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      if(_this.hasClass('slick-autoplay-next')){
        setInterval(function(){
          _this.slick('slickNext');
        },_autoplaySpeed);
      } else if(_this.hasClass('slick-autoplay-prev')){
        setInterval(function(){
          _this.slick('slickPrev');
        },_autoplaySpeed);
      }
    });


$('.embed-responsive-item.poster,.embed-responsive .play-icon').on('click',function(){
  var embedResponsive = $(this).parents('.embed-responsive').first();
  embedResponsive.find('.poster,.play-icon,.toggle-info,.caption').addClass('d-none');
  embedResponsive.find('.video').removeClass('d-none').trigger('click');
});


$('.blog-listing-section .btn.more-posts').on('click',function(){
  $(this).remove();
  $('.blog-listing-section .blog-col-wrap').removeClass('d-none');
  setTimeout(function(){
    $('.blogPosts-wrap .post-name-wrap').matchHeight();
  },100);
});

$('#navbar1').on('hide.bs.collapse', function () {
  // $('.nav-bg').removeClass('invisible');
});

$('#navbar1').on('show.bs.collapse', function () {
  // $('.nav-bg').addClass('invisible');
});


$('.wpcf7').each(function () {
  var mailTo = $('.person-contant-section .contact-mail-to').first().text().trim();

  if($(this).find('.form-recepient').length){
    $(this).find('.form-recepient').first().val(mailTo);
  }
  if($(this).find('.form-subject').length){
    $(this).find('.form-subject').first().val(document.title);
  }

});








  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js